import styled from 'styled-components';
import {
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
	buttonBorderColors,
} from '~/components/ui/Button';

const ContentContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 20px;
	gap: 15px;
	overflow: hidden;
`;

const CodeTextarea = styled.textarea`
	flex: 2;
	min-height: 350px;
	background-color: rgba(255, 255, 255, 0.05);
	color: #ffffff;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: ${ButtonBorderRadius.Radius10}px;
	padding: 15px 20px;
	font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
	font-size: 14px;
	line-height: 1.5;
	resize: none;
	outline: none;
	transition:
		background-color 0.3s ease,
		border 0.3s ease;

	&:focus {
		background-color: rgba(255, 255, 255, 0.08);
		border-color: rgba(255, 255, 255, 0.25);
	}

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
		transition: color 0.3s ease;
	}
`;

const ButtonRow = styled.div`
	display: flex;
	gap: 15px;
	justify-content: flex-end;
	align-items: center;
`;

const StyledButton = styled.button<{ $color: ButtonColors }>`
	min-width: 130px;
	height: ${ButtonHeight.Height50}px;
	background-color: ${(props) => props.$color};
	color: #ffffff;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	font-weight: 500;
	border: none;
	border-radius: ${ButtonBorderRadius.Radius10}px;
	cursor: pointer;
	transition:
		background-color 0.3s ease,
		color 0.3s ease,
		opacity 0.3s ease;

	&:not(:disabled):hover {
		background-color: #ffffff;
		color: #000000;
	}

	&:disabled {
		opacity: 0.25;
		cursor: not-allowed;
	}

	&:focus-visible {
		outline: none;
	}
`;

const ClearButton = styled.button`
	min-width: 100px;
	height: ${ButtonHeight.Height50}px;
	background-color: ${ButtonColors.Default};
	color: #ffffff;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	font-weight: 500;
	border: 1px solid ${buttonBorderColors[ButtonColors.Default]};
	border-radius: ${ButtonBorderRadius.Radius10}px;
	cursor: pointer;
	transition:
		background-color 0.3s ease,
		color 0.3s ease,
		border 0.3s ease;

	&:not(:disabled):hover {
		background-color: #ffffff;
		color: #000000;
		border: 1px solid #ffffff;
	}

	&:disabled {
		opacity: 0.25;
		cursor: not-allowed;
	}

	&:focus-visible {
		outline: none;
	}
`;

export { ButtonRow, ClearButton, CodeTextarea, ContentContainer, StyledButton };
